import { useContext } from 'react'
import { VetClinicContext } from '@/context'

export const useVetClinic = () => {
  const ctx = useContext(VetClinicContext)
  if (!ctx) throw new Error('useVetClinic must be used within a VetClinicProvider')
  return ctx
}
